export default "__VITE_ASSET__uEwWu3xd__"